export default {
  toastErrorTitle: {
    id: 'buyback_error_toast_title',
    defaultMessage: 'Oh no!',
  },
  toastErrorContent: {
    id: 'buyback_error_toast_content',
    defaultMessage: 'Something went wrong. Try again later.',
  },
  toastClose: {
    id: 'buyback_toast_close',
    defaultMessage: 'Close',
  },
}
